import { render } from "./StagePlayer.vue?vue&type=template&id=2f9eb6c4&scoped=true&ts=true"
import script from "./StagePlayer.vue?vue&type=script&lang=ts"
export * from "./StagePlayer.vue?vue&type=script&lang=ts"

import "./StagePlayer.vue?vue&type=style&index=0&id=2f9eb6c4&lang=scss&scoped=true"

import exportComponent from "C:\\Projekty\\VideoPLayer\\player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9eb6c4"]])

export default __exports__